<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="active-wrap container">
      <titleConfig :title="title" :type="2"></titleConfig>
      <div class="active-content">
        <div class="active-tab flex">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="langSet == 'cn' ? '全部' : 'All'" :name="''"></el-tab-pane>
            <template v-for="item in time">
              <template v-for="items in item.months">
                <template v-for="(days, daysIndex) in items.days">
                  <el-tab-pane
                    :label="`${item.year}.${items.month}.${days.day}`"
                    :name="String(days.timestamp)"
                    :key="daysIndex"
                  ></el-tab-pane>
                </template>
              </template>
            </template>
          </el-tabs>
        </div>
        <div v-loading="loading">
          <active :list="list" :type="'3'"></active>
          <nodata v-if="list.length == 0"></nodata>
        </div>
        <div class="page_wrap flex flex_content_center">
          <el-pagination
            v-if="totals > 6"
            background
            layout="prev, pager, next"
            :total="totals"
            :page-size="6"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import active from "@/components/active.vue";
import { timeLists, activityList } from "@/api/api";
import nodata from "../../components/nodata.vue";

export default {
  // 配置title和meta数据
  // metaInfo() {
  //   return {
  //     title: this.metaData.name_cn,
  //     meta: [
  //       {
  //         name: "description",
  //         content: this.metaData.description,
  //       },
  //       {
  //         name: "keywords",
  //         content: this.metaData.keywords,
  //       },
  //     ],
  //   };
  // },
  components: {
    top,
    bottom,
    titleConfig,
    active,
    nodata,
  },
  data() {
    return {
      loading: false,
      langSet: "",
      metaData: {},
      time: [],
      list: [],
      id: 0,
      ymd: "",
      title: "",
      totals: 0,
      pageNo: 1,
      pageSize: 6,
      activeName: "",
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    this.title = this.$route.query.title;
    //25.9.17 获取活动时间 dxm
    this.getTimeLists();
    //25.9.17 获取活动列表 dxm
    this.getActivityList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getTimeLists() {
      let data = {
        classid: this.id,
      };
      const res = await timeLists(data);
      this.time = res.data;
    },
    async getActivityList() {
      let data = {
        classid: this.id,
        ymd: this.ymd,
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      this.loading = true;
      const res = await activityList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
      this.loading = false;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getActivityList();
    },
    handleClick(tab, event) {
      this.ymd = tab.name;
      this.pageNo = 1;
      this.getActivityList();
    },
    tabClick(ymd) {
      this.ymd = ymd;
      this.pageNo = 1;
      this.getActivityList();
    },
    toList(item) {
      this.$router.push({
        path: "/activeList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.active-wrap {
  padding: 80px 0;
  min-height: 500px;
  .active-content {
    .active-tab {
      margin: 30px 0;
      /deep/ .el-tabs {
        width: 100%;
      }
      /deep/ .el-tabs__header {
        margin: 0;
      }
      /deep/ .el-tabs__nav-wrap::after,
      /deep/ .el-tabs__active-bar {
        display: none;
      }
      /deep/ .el-tabs__item {
        font-size: 16px;
        color: #444;
        height: 42px;
        padding: 0 20px;
        text-align: center;
        min-width: 120px;
        font-weight: normal;
        line-height: 42px;
        margin-right: 20px;
        border-radius: 22px;
        box-sizing: border-box;
        background: #eee;
        border-radius: 21px;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: #fff;
          background: #1d2379;
        }
      }
      /deep/ .el-tabs__item.is-active {
        color: #fff;
        background: #1d2379;
      }
    }
  }
  .page_wrap {
    margin-top: 40px;
  }
}

@media only screen and (max-width: 767px) {
  .active-wrap {
    padding: 0.58rem 0;
    .active-content {
      .active-tab {
        /deep/ .el-tabs__item {
          min-width: 1.5rem;
          height: 0.65rem;
          margin-right: 0.19rem;
          font-size: 0.27rem;
          line-height: 0.65rem;
          border: 1px solid #eee;
        }
        /deep/ .el-tabs__nav-next,
        /deep/ .el-tabs__nav-prev {
          line-height: 30px;
        }
      }
    }
  }
}
</style>